import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ShipperOrderEditModal from 'modules/shipper-order/EditModal';

import { closeModal } from 'redux/modules/shipper-order-edit/effects';

import { compose, withHandlers } from 'recompose';

const enhance = compose(
  connect(null, { closeModal }),
  withHandlers({
    onCloseHandler:
      ({ closeModal, history }) =>
      () => {
        closeModal(history.action);
      },
  })
);

const EditShipperOrder = React.memo(({ match, onCloseHandler }) => {
  return <ShipperOrderEditModal onClose={onCloseHandler} shipperOrderId={match.params.id} />;
});

EditShipperOrder.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  onCloseHandler: PropTypes.func,
};

export default enhance(EditShipperOrder);
